import PropTypes from 'prop-types';
import { createContext, useCallback, useContext, useMemo } from 'react';
// hooks
import useLocalStorage from '../../hooks/useLocalStorage';
//
import { defaultSettings } from './config-setting';
import { defaultPreset } from './presets';

// ----------------------------------------------------------------------

// The theme is fixed: light, the default green, left to right, standard width. The settings panel that changed
// these is gone (right to left crashed the dashboard to a white screen), and settings it saved are ignored.
// The one choice left is collapsing the sidebar, remembered in this browser.

const initialState = {
  ...defaultSettings,
  presetsColor: defaultPreset,
  onToggleLayout: () => {},
  // The language switcher calls this; the direction stays left to right
  onChangeDirectionByLang: () => {},
};

// ----------------------------------------------------------------------

export const SettingsContext = createContext(initialState);

export const useSettingsContext = () => {
  const context = useContext(SettingsContext);

  if (!context) throw new Error('useSettingsContext must be use inside SettingsProvider');

  return context;
};

// ----------------------------------------------------------------------

SettingsProvider.propTypes = {
  children: PropTypes.node,
};

export function SettingsProvider({ children }) {
  const [navLayout, setNavLayout] = useLocalStorage('nav-layout', 'vertical');

  // The collapse button beside the sidebar
  const onToggleLayout = useCallback(() => {
    setNavLayout((layout) => (layout === 'mini' ? 'vertical' : 'mini'));
  }, [setNavLayout]);

  const memoizedValue = useMemo(
    () => ({
      ...initialState,
      themeLayout: navLayout === 'mini' ? 'mini' : 'vertical',
      onToggleLayout,
    }),
    [navLayout, onToggleLayout]
  );

  return <SettingsContext.Provider value={memoizedValue}>{children}</SettingsContext.Provider>;
}
